import { TemporalSettingsProvider } from '@frontend/utils';

import { useAppSelector } from 'store/hooks';
import { getPreferredDateFormat } from 'store/session/selectors';

export const DateSettings = ({
  children,
}: React.PropsWithChildren<unknown>) => {
  const preferredDateFormat = useAppSelector(getPreferredDateFormat);

  return (
    <TemporalSettingsProvider preferredDateFormat={preferredDateFormat}>
      {children}
    </TemporalSettingsProvider>
  );
};
